import React from 'react'
import { useSelector } from 'react-redux'

import { Helmet } from 'react-helmet'

import { META_TAGS } from '../../utils/constants'
import { HELPER } from '../../utils'

function MetaTags() {
	const {
		meta_title,
		meta_description,
		open_graph_title,
		open_graph_image,
		open_graph_description,
		page_title,
	} = useSelector((state) => state.config.app_seo)

	return (
		<Helmet>
			<title>{!HELPER.isEmpty(page_title) ? page_title : META_TAGS.PAGE_TITLE}</title>
			{!HELPER.isEmpty(meta_title) ? <meta name="title" content={meta_title} /> : ''}
			{!HELPER.isEmpty(meta_description) ? (
				<meta name="description" content={meta_description} />
			) : (
				''
			)}
			{!HELPER.isEmpty(open_graph_title) ? <meta name="og:title" content={open_graph_title} /> : ''}
			{!HELPER.isEmpty(open_graph_image) ? <meta name="og:image" content={open_graph_image} /> : ''}
			{!HELPER.isEmpty(open_graph_description) ? (
				<meta name="og:description" content={open_graph_description} />
			) : (
				''
			)}
		</Helmet>
	)
}

export default MetaTags
